import {httpGet,httpPost} from '../../../api/base'
import config from '../../../config/config'
const url_pre = config.default_domin;

export default {
	searchCares(params,cb){
		httpGet(`${url_pre}/api/fe/v1/private/p/plan/list`,params).then((res)=>{
			if(res.data.errno==0){
				cb(res.data.body)
			}else{
				cb(res.data)
			}
		})
	},
	searchScene(params,cb){
		httpGet(`${url_pre}/api/fe/v1/private/j/caresplan/plan/searchSceneCategory`,params).then((res)=>{
			if(res.data.errno==0){
				cb(res.data.body)
			}else{
				cb(res.data)
			}
		})
	},
	closePlan(params,cb){
		httpPost(`${url_pre}/api/fe/v1/private/p/Plan/doClose`,params).then((res)=>{
			if(res.data.errno==0){
				cb(res.data.body)
			}else{
				cb(res.data)
			}
		})
	},
	planListExport(params,cb){
		httpPost(`${url_pre}/api/fe/v1/private/p/Plan/planListExport`,params).then((res)=>{
			if(res.data){
				cb(res.data)
			}
		})
	},
		// 获取下载链接
		getExportDownloadUrl(params,cb) {
			httpGet(config.default_domin+'/api/fe/v1/j/oms/export/download',params).then((res)=>{
				if(res.data) {
					cb(res.data)
				}
			})
		},
}